/**
 * -------------------------------------------------------------------------------------------
 * JSON ANIMATIONS
 * -------------------------------------------------------------------------------------------
 */

//JSON animations
document.addEventListener('DOMContentLoaded', function () {
  var animationContainers = document.querySelectorAll('.animation-container');
  var animationContainersMobile = document.querySelectorAll(
    '.animation-container-mobile'
  );

  animationContainers.forEach(function (container) {
    var jsonUrl = container.getAttribute('data-json-url');
    if (jsonUrl) {
      lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: jsonUrl,
      });
    }
  });

  animationContainersMobile.forEach(function (container) {
    var jsonUrl = container.getAttribute('data-json-url');
    if (jsonUrl) {
      lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: jsonUrl,
      });
    }
  });
});

/**
 * -------------------------------------------------------------------------------------------
 * A.I. GENERATED IMAGE LABELS
 * -------------------------------------------------------------------------------------------
 */

(function () {
  const aiImageSelector = 'img[alt^="KI_"], img[alt^="KI-"]';

  function addAiGeneratedLabel(image) {
    if (image.dataset.aiGeneratedLabelled === 'true') {
      return;
    }

    const picture = image.closest('picture');
    const wrapper = picture ? picture.parentElement : image.parentElement;

    if (!wrapper) {
      return;
    }

    if (window.getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    const label = document.createElement('span');
    label.classList.add('ai-generated-image-label');
    label.setAttribute('aria-hidden', 'true');
    label.textContent = 'A.I. generated';

    Array.from(image.classList).forEach(function (className) {
      if (className.startsWith('hidden-')) {
        label.classList.add(className);
      }
    });

    if (picture) {
      picture.insertAdjacentElement('afterend', label);
    } else {
      image.insertAdjacentElement('afterend', label);
    }

    image.dataset.aiGeneratedLabelled = 'true';
  }

  function processAiGeneratedImages(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    if (root.matches(aiImageSelector)) {
      addAiGeneratedLabel(root);
    }

    root.querySelectorAll(aiImageSelector).forEach(addAiGeneratedLabel);
  }

  document.querySelectorAll(aiImageSelector).forEach(addAiGeneratedLabel);

  const aiImageObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(processAiGeneratedImages);
    });
  });

  aiImageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
